export default __webpack_public_path__ + "static/media/G+.577e3cd0.svg";